import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'filterPipeCloseCash'
})
export class FilterPipeCloseCash implements PipeTransform {
    transform(historials: any, term?: any): any {
        if (term === undefined) return historials;
        if (term === null) return historials;

        if (historials != null) {
            return historials.filter(function (historial) {
                if (historial.cash != undefined)
                    if (historial.cash.toString().toLowerCase().includes(term.toLowerCase()))
                        return historial;
                if (historial.name != undefined)
                    if (historial.name.toString().toLowerCase().includes(term.toLowerCase()))
                        return historial;
                if (historial.date != undefined)
                    if (moment(new Date(historial.date.toDate())).format("DD/MM/YYYY HH:mm:ss").toString().toLowerCase().includes(term.toLowerCase()))
                        return historial;
                if (historial.total != undefined)
                    if (historial.total.toString().toLowerCase().includes(term.toLowerCase()))
                        return historial;
                if (historial.user_closed != undefined)
                    if (historial.user_closed.toString().toLowerCase().includes(term.toLowerCase()))
                        return historial;
            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-close-cash/filter.pipe.ts